// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import { Link } from 'react-router-dom';
import './EventTags.scss';

type Props = {
  tags: string[],
};

const EventTags = ({ tags }: Props) => (
  <div className="EventTags">
    {tags.map(t => (
      <Link to={`/tags/${escapeForUrl(t)}`} key={t}>
        {t}
      </Link>
    ))}
  </div>
);

export default EventTags;



// WEBPACK FOOTER //
// ./src/components/event/EventTags/EventTags.js